module.exports = __webpack_public_path__ + "img/logo-sonda-footer.e91efe64.png";